import React, { useContext } from 'react'
import DetailCardWithTable from '../../../dpe-usco/components/Details/DetailCardWithTable'
import { GlobalContext } from '../../../services/context'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

export const ProductionPlansWidget = ({ data, status, company_id }) => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const clickYear = (e, obj) => {
    e.preventDefault()
    const detailView = {
      title: `Production Plan: ${obj.contract_year}`,
      previous: obj.company_name
    }
    trackEvent('production_plan_link_clicked', { companyId: company_id, productionPlanDetails: obj })
    dispatch({ type: 'GO_TO_VIEW_PRODUCTION_PLAN', payload: { company_id, productionPlanDetails: obj, detailView } })
  }

  const headerCell = value => {
    return (
      <div key={value} className="cell df aic">
        <span>{value}</span>
      </div>
    )
  }
  const structure = {
    headers: [
      {
        value: 'Year',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Total Bushels',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Unit Type',
        format() {
          return headerCell(this.value)
        }
      }
    ],
    dataKeys: [
      'contract_year', 'total_units', 'unit_type'
    ],
    rowFormat: {
      contract_year: {
        allContent: true,
        format: planInfo => {
          return (
            <a
              className="c-blue-500 c-blue-700:h tdu:h"
              href={`production-plan/${planInfo.production_plan_id}`}
              onClick={e => {
                clickYear(e, planInfo)
              }}
            >
              {planInfo.contract_year}
            </a>
          )
        }
      }
    }
  }

  return (
    <DetailCardWithTable
      title={'Production Plans'}
      structure={structure}
      data={data}
      statusComponent={status ? <TableStatus status={status} /> : null}
    />
  )
}

export default ProductionPlansWidget
